import { JSX } from 'react';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { C48ReputationScheduleCTAProps } from './C48ReputationScheduleCTA.types';
import { PromptForUnavailableInTheme } from 'src/shared/PromptForUnavailableInTheme';
import { ReputationScheduleCta } from '@ahc-digital/component-library';
import { CreateReputationScheduleCTAModel } from './C48ReputationScheduleCTA.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

export const Default = (props?: C48ReputationScheduleCTAProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const doctorSearchURL: string = context?.doctorSearchURL?.value ?? '';
  const locationSearchURL: string = context?.locationSearchURL?.value ?? '';
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (context?.siteTheme?.value === 'Corporate')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value}
        componentName={props?.rendering?.componentName}
      />
    );

  const model = CreateReputationScheduleCTAModel(props, doctorSearchURL, locationSearchURL);
  return <ReputationScheduleCta {...model} data-component={marketingRenderingName} />;
};

export default checkDatasourceForRendering<C48ReputationScheduleCTAProps>(Default);
